module.exports = __webpack_public_path__ + "static/media/loginImg.101e1e3c.svg";